<div class="main-component">
  <div class="overlay" (click)="closeOverlay(false, $event)" [class.show]="this.activeIndex !== -1"></div>

  <div class="headline-box">
    @if (!isMobile) {
      <h1 class="title">
        <span fiTranslation="REQUEST_OVERVIEW_FILTER_HEADLINE_REQUEST"></span> ({{ leadsCount }})
      </h1>
    }

    <fi-files-management class="actions-buttons-box"></fi-files-management>
  </div>

  <fi-requests-overview-top-bar
    [filters]="filters"
    [isMobile]="isMobile"
    [compactView$]="compactView$"
    [isFinstralUser]="isFinstralUser"
    [(showFiltersOnMobile)]="showFiltersOnMobile"
    (filtersChanged)="loadLeads()"
    (queryChanged)="onQueryChanged($event)"
    (categoryTypeChanged)="onCategoryTypeChanged($event)"
    (rangeSelected)="onRangeSelect($event)"
    (compactViewToggle)="onCompactViewToggle($event)"
    (sortChanged)="onMobileSortChanged($event)"
  ></fi-requests-overview-top-bar>

  <fi-requests-overview-filter-chips
    [filters]="filters"
    [isMobile]="isMobile"
    (filterRemoved)="removeFilter($event.filters, $event.index)"
    (dateFilterCleared)="clearDateRange()"
    (allFiltersRemoved)="removeAllSelectedTabs()"
    (sortBadgeClicked)="openMobileSortFilter()"
  ></fi-requests-overview-filter-chips>

  @if (isMobile && leadsCount && filters.search) {
    <div class="mobile-result-summary">
      <div class="separator"></div>
      <div class="summary-text">
        <span
          class="summary-label"
          fiTranslation="REQUEST_OVERVIEW_SEARCH_RESULT_SUMMARY"
          [params]="{ count: leadsCount, search: filters.search }"
        ></span>
      </div>
    </div>
  }

  <div class="overview-container f_overview-container" [class.has-items]="contactLeads?.length && !filters.search">
    @if (!isMobile) {
      <fi-requests-overview-desktop-container
        [filters]="filters"
        [contactLeads]="contactLeads"
        [checkedAll]="checkedAll"
        [filterType]="filterType"
        [showFilterSelectBox]="showFilterSelectBox"
        [compactView$]="compactView$"
        [checkedLeads]="checkedLeads"
        [activeIndex]="activeIndex"
        [activeCellHeight]="activeCellHeight"
        [userId]="userId"
        [isFinstralUser]="isFinstralUser"
        [leadsCount]="leadsCount"
        [visibleLeadsCount]="visibleLeadsCount"
        [pagesCount]="pagesCount"
        [searchFilterOpen]="searchFilterOpen"
        [multiSelectDataLoaded]="multiSelectDataLoaded"
        [multiselectNameKey]="multiselectNameKey"
        [multiselectSelectedOptions]="multiselectSelectedOptions"
        [multiselectOptions]="multiselectOptions"
        [showActions]="showActions"
        [expandedLeadLinkId]="expandedLeadLinkId"
        [getAddress]="getAddress"
        [getLeadTakenMessage]="getLeadTakenMessage"
        (expandedLeadLinkIdChange)="expandedLeadLinkId = $event"
        (showActionsChange)="showActions = $event"
        (checkAllFieldsRequested)="checkAllFields($event)"
        (sortByColumnRequested)="sortByColumn($event)"
        (openMultiselectFilterRequested)="openMultiselectFilter($event)"
        (openSearchFilterRequested)="openSearchFilter($event)"
        (multiselectChanged)="onMultiselectChanged($event)"
        (addFilterRequested)="addFilter($event.filterType, $event.value)"
        (rejectAssignmentRequested)="rejectAssignment($event)"
        (confirmAssignmentRequested)="confirmAssignment($event)"
        (openLeadDetailsRequested)="openLeadDetails($event.id, $event.newTab)"
        (duplicateClickRequested)="onDuplicateClick($event)"
        (checkLeadRequested)="checkLead($event)"
        (openMapNewTabRequested)="openMapNewTab($event.event, $event.lead)"
        (openSuggestedActionPopupRequested)="openSuggestedActionPopup($event)"
        (openActionPopupRequested)="openActionPopup($event.index, $event.event)"
        (closeOverlayRequested)="closeOverlay($event)"
        (markAsUnreadRequested)="markAsUnread($event)"
        (markAsReadRequested)="markAsRead($event)"
        (prevPageRequested)="prevPage()"
        (nextPageRequested)="nextPage()"
      ></fi-requests-overview-desktop-container>
    }

    @if (isMobile) {
      <fi-requests-overview-mobile-container
        [contactLeads]="contactLeads"
        [compactView$]="compactView$"
        [expandedLeads]="expandedLeads"
        [leadsCount]="leadsCount"
        [visibleLeadsCount]="visibleLeadsCount"
        [filters]="filters"
        [pagesCount]="pagesCount"
        (rejectAssignmentRequested)="rejectAssignment($event)"
        (confirmAssignmentRequested)="confirmAssignment($event)"
        (toggleExpandedLeadRequested)="toggleExpandedLead($event)"
        (duplicateClickRequested)="onDuplicateClick($event)"
        (openLeadDetailsRequested)="openLeadDetails($event.id, $event.newTab)"
        (prevPageRequested)="prevPage()"
        (nextPageRequested)="nextPage()"
      ></fi-requests-overview-mobile-container>
    }
  </div>
</div>
